module.exports = __webpack_public_path__ + "img/goal.71da69ee.png";